import { supabase } from '../supabaseClient';

/**
 * One place for the API base URL.
 *
 * These calls were hardcoded to http://localhost:8000, so in production they asked the
 * visitor's own machine and failed with "Failed to fetch" regardless of configuration.
 * CRA inlines REACT_APP_* at build time, so the Dockerfile passes it as a build arg.
 */
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

/** Supabase access token, for endpoints that require a signed-in caller. */
export async function authHeaders() {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data && data.session && data.session.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch (e) {
    return {};
  }
}
